/**
 * @generated SignedSource<<f0acfac12c0a84422e72d7c62a129f43>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ListItemDescriptionContentFiles_files$data = ReadonlyArray<{
  readonly id: string;
  readonly " $fragmentSpreads": FragmentRefs<"FileIconBox_file">;
  readonly " $fragmentType": "ListItemDescriptionContentFiles_files";
}>;
export type ListItemDescriptionContentFiles_files$key = ReadonlyArray<{
  readonly " $data"?: ListItemDescriptionContentFiles_files$data;
  readonly " $fragmentSpreads": FragmentRefs<"ListItemDescriptionContentFiles_files">;
}>;

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "ListItemDescriptionContentFiles_files",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "FileIconBox_file"
    }
  ],
  "type": "File",
  "abstractKey": null
};

(node as any).hash = "c15ff34aa836a6a90ed86686c6692a7e";

export default node;
